import React from 'react';
import { FRONT_BUSINESS_URL } from '../../routing';
import { createBusinessPageShareText } from '../../Social/TwitterButton';
import SnsButtonGroup from '../SnsButtonGroup';

interface XsSnsShareButtonProps {
  id: number;
  name: string;
  regionName?: string | null;
  /** 施設ページ用。指定時はこのURLをシェアに使用（未指定時は id から事業者ページURLを生成） */
  pageUrl?: string | null;
}

// 事業者ページ／施設ページで単独利用するために定義。ReactRailsから呼ばれる。
export const XsSnsShareButton = ({
  id,
  name,
  regionName,
  pageUrl: pageUrlFromProps,
}: XsSnsShareButtonProps) => {
  const businessPageUrl =
    pageUrlFromProps ?? FRONT_BUSINESS_URL.replace(':id', id.toString());
  const twitterShareText = createBusinessPageShareText(
    name,
    businessPageUrl,
    regionName || '',
  );
  return (
    <SnsButtonGroup
      hiddenProps={{ smUp: true }}
      justify="center"
      gutterBottom
      loaded
      tweetText={twitterShareText}
      url={businessPageUrl}
    />
  );
};

export default XsSnsShareButton;
